// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_xSr","cls2":"Base-cls2_cp6 Base-cls1_xSr"};